/* eslint-disable react-hooks/exhaustive-deps */
import { getPromptFragmentsAPI } from "Api/promptFragments";
import { useGlobalContext } from "context/globalContext";
import React, { useCallback, useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import Loader from "components/loader/Loader";
import toast from "react-hot-toast";
import { consoleLog } from "helpers";

const PreviewPromptFragmentsModal = ({ isOpen, onClose }) => {
  const {
    promptFragmentsFormData,
    setPromptFragmentsFormData,
    initialPromptFragmentsFormState,
  } = useGlobalContext();
  const [/* promptData */, setPromptData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleCancel = useCallback(() => {
    setPromptFragmentsFormData(initialPromptFragmentsFormState);
    onClose();
  }, [initialPromptFragmentsFormState, onClose, setPromptFragmentsFormData]);

  const getPromptFragments = useCallback(async () => {
    consoleLog([promptFragmentsFormData, "promptFragmentsId"]);
    const token = localStorage.getItem("jwtToken");
    const response = await getPromptFragmentsAPI(
      setIsLoading,
      token,
      promptFragmentsFormData.id
    );
    if (response) {
      consoleLog([response, "previewpromptFragmentsData"]);
      setPromptData(response);
    }
    if (!response) {
      toast.error("Failed to fetch system prompt data");
      handleCancel();
    }
  }, [handleCancel, promptFragmentsFormData.id]);

  useEffect(() => {
    if (isOpen) getPromptFragments();
  }, [getPromptFragments, isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.height = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.body.style.height = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      {/* Black overlay */}
      <div
        className="fixed inset-0 z-[100] bg-[black] bg-opacity-75 transition-opacity"
        onClick={handleCancel}
      />

      {/* Modal content */}
      <div className="bg-black fixed inset-0 z-[101] flex h-screen items-center justify-center overscroll-contain bg-opacity-50">
        <div className="relative z-50 mx-auto flex max-h-[95dvh] w-4/5 flex-col items-center justify-start overflow-auto rounded-xl bg-white p-6 shadow-xl dark:!bg-gray-10 dark:text-white">
          <button
            type="button"
            onClick={handleCancel}
            className="absolute top-6 right-6 text-gray-500 hover:text-gray-600 focus:outline-none dark:hover:text-gray-100 "
          >
            <IoMdClose size={24} />
          </button>

          {isLoading ? (
            <div className="flex h-[400px] w-full items-center justify-center">
              <Loader />
            </div>
          ) : (
            <div className="w-full">
              <div className="mt-4 flex justify-center gap-4">
                <div className="w-1/2">
                  <label className="mb-2 block font-bold text-gray-700">
                    Name:
                  </label>
                  <div className="rounded-md border border-gray-300 px-3 py-2">
                    {promptFragmentsFormData?.name || "N/A"}
                  </div>
                </div>
                <div className="w-1/2">
                  <label className="mb-2 block font-bold text-gray-700">
                    Key:
                  </label>
                  <div className="rounded-md border border-gray-300 px-3 py-2">
                    {promptFragmentsFormData?.key || "N/A"}
                  </div>
                </div>
              </div>

              <div className="mt-4 flex justify-center gap-4">
                <div className="w-1/2">
                  <label className="mb-2 block font-bold text-gray-700">
                    Status:
                  </label>
                  <div className="rounded-md border border-gray-300 px-3 py-2">
                    <span
                      className={`${
                        promptFragmentsFormData?.isActive === "active"
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                    >
                      {promptFragmentsFormData?.isActive === "active"
                        ? "Active"
                        : "In-Active"}
                    </span>
                  </div>
                </div>
                <div className="w-1/2">
                  <label className="mb-2 block font-bold text-gray-700">
                    LLM:
                  </label>
                  <div className="min-h-[2.75rem] rounded-md border border-gray-300 px-3 py-2">
                    {promptFragmentsFormData?.LLM || "N/A"}
                  </div>
                </div>
              </div>
              <div className="mt-4 flex justify-start gap-4">
                <div className="w-1/2">
                  <label className="mb-2 block font-bold text-gray-700">
                    Comment:
                  </label>
                  <div className="min-h-[2.75rem] rounded-md border border-gray-300 px-3 py-2">
                    {promptFragmentsFormData?.comment || "N/A"}
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <label className="mb-2 block font-bold text-gray-700">
                  Value:
                </label>
                <div className="max-h-[36dvh] overflow-auto whitespace-pre-wrap rounded-md border border-gray-300 px-3 py-2">
                  {promptFragmentsFormData?.value || "N/A"}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PreviewPromptFragmentsModal;
